import { forwardRef, memo, useImperativeHandle, useState } from "react";
import { Calendar } from "@material-ui/pickers";
import { parseISO, isWithinInterval, set } from "date-fns";
import { css } from "styled-components";
import planningColors, { darkenColor } from "../../Classes/colors/planningColors";
import { useCalendar } from "../Stores/CalendarProvider";
import { withStyles } from '@material-ui/core/styles';
import { Tooltip } from "@material-ui/core";

const CalendarOfAMonth = memo(({
  month, absences, startDate, endDate,
  isHoliday, getPeriodTypeForDay,
  classes, periods, isClassAuthorized,
  handleDayClick, selectedStartDay, selectedEndDay
}) => {

  const [hoveredPeriodId, setHoveredPeriodId] = useState(null);
  const [htmlBeforeHover, setHtmlBeforeHover] = useState(null);
  const { state, dispatch } = useCalendar();



  // const modifyButton = `
  // <div style="
  //   position: absolute;
  //   top: -20px;
  //   left: 30%;
  //   z-index: 10;
  //   "
  //   >
  //   <button>Modifier</button>
  // </div>
  // `
  // const handleHover = (periodId) => {
  //   

  //   setHoveredPeriodId(periodId);
  //   dispatch({ type: "SET_HOVERED_PERIOD_ID", payload: periodId })

  //   if (!periodId) return;
  //   const testDom = document.querySelector(`.period-${periodId}`);
  //   

  //   setHtmlBeforeHover(testDom.parentElement.parentElement.innerHTML);

  //   if (document.querySelector(".wrapperPeriodActive")) return;
  //   if (testDom) {
  //     testDom.parentElement.parentElement.innerHTML = `
  //   <div style="
  //     display: flex;
  //     position: relative;
  //   "
  //   class="wrapper-period-active"
  //   >
  //   ${modifyButton}
  //   ${testDom.parentElement.parentElement.innerHTML}
  //   </div>
  //   `
  //   }
  // }

  // const handleExitHover = () => {
  //   
  //   setHoveredPeriodId(null);

  //   dispatch({ type: "SET_HOVERED_PERIOD_ID", payload: null });
  //   const testDom = document.querySelector(`.period-${hoveredPeriodId}`);
  //   const wrapper = document.querySelector(".wrapper-period-active")
  //   

  //   if (wrapper) {
  //     testDom.parentElement.parentElement.innerHTML = htmlBeforeHover;
  //   }
  // }


  const LightTooltip = withStyles(({ shadows }) => ({
    tooltip: {
      backgroundColor: "#333",
      color: '#FFF',
      boxShadow: shadows[1],
      '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
      fontWeight: 600,
    },
    tooltipPlacementRight: {
      margin: '0 ',
    }
  }))(Tooltip);

  return (
    <div className={classes.calendarWrapper}>
      <Calendar
        date={month}
        onChange={() => { }}
        renderDay={(day, selectedDate, isInCurrentMonth, dayComponent) => {
          const isWeekend = day.getDay() === 6 || day.getDay() === 0; // 6 = samedi, 0 = dimanche
          const holiday = isHoliday(day);
          const period = getPeriodTypeForDay(day);
          const periodType = period ? period.type : null;
          const periodId = period ? period.id : null;

          const isAbsent = absences.some(absence =>
            isWithinInterval(day, {
              start: parseISO(absence.startDate),
              end: parseISO(absence.endDate),
            })
          );

          const isDisabled =
            day < new Date(startDate) || day > new Date(endDate) || !isInCurrentMonth;

          const isInRange =
            selectedStartDay &&
            selectedEndDay &&
            day >= selectedStartDay &&
            day <= selectedEndDay &&
            isInCurrentMonth;

          const isWeekendAndVacation = isWeekend && periodType === "VACANCES";

          const classNames = [
            classes.dayCell,
            periodId && `period-${periodId}`,
            isDisabled && "disabled",
            isWeekendAndVacation ? "VACANCES" : isWeekend && "weekend",
            holiday && "holiday",
            !isInCurrentMonth && "outOfMonth",
            !isWeekendAndVacation && periodType,
            day.getTime() === selectedStartDay?.getTime() && "selectedStart",
            day.getTime() === selectedEndDay?.getTime() && "selectedEnd",
            isInRange && "selectedRange",
          ]

            .filter(Boolean)
            .join(" ");

          return (
            <div
              className={classNames}
              onClick={() => handleDayClick(day)}
            >
              <LightTooltip
                interactive={true}
                title="Modifier"
                placement='top'
              >
                <div
                  onClick={() => {
                  }}
                >
                  {dayComponent}
                </div>
              </LightTooltip>
            </div>
          );
        }}
      />
    </div>
  );
});

export default CalendarOfAMonth;
